<div class="page-container" [class.mat-background-primary-lighter]="!isDialog" [class.mobile]="rwdService.isSmallDevice">
  <div class="page-height container" [class.mobile]="rwdService.isSmallDevice" [class.wide]="!legacy">
    <div class="header" *ngIf="!isDialog">
      <ng-content select="[head]"></ng-content>
      <button mat-icon-button class="close-icon" type="button" [routerLink]="exitLink">
        <mat-icon inline>close</mat-icon>
      </button>
    </div>

    <ng-content select="[body]" *ngIf="loaded; else loader"></ng-content>

    <div *ngIf="!isSubmitting; else loader" class="buttons" [class.old]="legacy">
      <ng-container *ngFor="let button of buttons">
        <button
          [class]="button.class"
          [attr.form]="formId"
          (click)="onClickHandler(button)"
          [routerLink]="button.isExit && !isDialog ? exitLink : null"
          [matTooltip]="button.tooltipKey | locLabel"
        >
          {{ button.labelKey | locLabel }}
        </button>
      </ng-container>
    </div>
  </div>

  <ng-template #loader>
    <app-loader></app-loader>
  </ng-template>
</div>
